import firebase from 'firebase/app';
import 'firebase/firestore';

export default (userId) => firebase.firestore().collection('users').doc(userId).get();
